import React from "react";

const About = () => {
  const cards = [
    {
      id: "01",
      title: "Post a Request",
      description:
        "Select the type of vehicle, describe what needs to be moved, and set the time and price that work for you. That’s all it takes to get started.",
    },
    {
      id: "02",
      title: "Get Offers from Drivers",
      description:
        "Drivers nearby see your request and send their offers. You can check their details, chat if needed, and pick the one that fits best.",
    },
    {
      id: "03",
      title: "Confirm and Go",
      description:
        "Once you choose a driver, everything moves forward as scheduled. You stay updated, and the job gets done the way you agreed.",
    },
  ];
  return (
    <div className="about-us-container">
      <span>ABOUT US</span>
      <span>A Platform Designed Around Trust, Speed, and Choice</span>
      <span>
        ZOWO is a fast, fair, and safe logistics platform that connects
        individuals and businesses with verified drivers, supporting direct
        price negotiation and transparent service across Saudi Arabia.
      </span>
      <div className="image-container"></div>
      <div className="about-us-card-container">
        <span>HOW WE WORK</span>
        <span>The Steps Between You and a Job Well Done</span>
        <div className="about-us-card">
          {cards.map((item) => {
            return (
              <div className="card-about">
                <span>{item.id}</span>
                <span>{item.title}</span>
                <span>{item.description}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default About;
